import { Injectable } from "../../helpers";

export class CashDrawerErrorHandlerService extends Injectable {
  static get $inject() {
    return ["$uibModal", "$translate"];
  }

  handleError(error, options = {}) {
    if (error.status !== 422 || !error.data || !error.data.error) {
      return false;
    }

    const errorCode = error.data.error;

    const errorHandlers = {
      CASH_DRAWER_IS_OPEN: () => this._showModal("CASH_DRAWER_IS_OPEN"),
      CASH_DRAWER_HAS_TRANSACTIONS: () =>
        this._showModal("CASH_DRAWER_HAS_TRANSACTIONS", {
          count: error.data.count || 0,
        }),
      CASH_DRAWER_HAS_BALANCE: () =>
        this._showModal("CASH_DRAWER_HAS_BALANCE", {
          amount: error.data.amount || "0.00",
        }),
      CASH_DRAWER_INACTIVE: () => this._showModal("CASH_DRAWER_INACTIVE"),
      CASH_DRAWER_CLOSED: () => this._showModal("CASH_DRAWER_CLOSED"),
      CASH_DRAWER_BALANCE: () =>
        this._showModal("CASH_DRAWER_BALANCE_CANNOT_BE_LESS_THAN_ZERO"),
    };

    if (errorHandlers[errorCode]) {
      errorHandlers[errorCode]();
      return true;
    }

    return false;
  }

  _showModal(messageKey, params = {}) {
    this.$uibModal.open({
      component: "infoModal",
      resolve: {
        title: () => this.$translate.instant("INFORMATION"),
        message: () => this.$translate.instant(messageKey, params),
      },
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/cash-drawer-error-handler.service.js